import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content";
import { EventContent } from "PFApp/components/card_tx/content/event_content";
import { Footer } from "PFApp/components/card_tx/footer/footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type EventVariantProps = Pick<
  CardTxContentProps,
  "activity" | "type" | "isFeed" | "isDraft" | "handleShare" | "handleRefetchActivities"
>;

export const EventVariant = ({
  activity,
  type,
  isFeed,
  isDraft,
  handleShare,
  handleRefetchActivities
}: EventVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    activity,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <Header {...commonHeaderProps} />
      <Status isPrivate={activity.private} isDraft={isDraft} />
      <EventContent activity={activity} />
      <Footer participants={activity.participants} />
    </>
  );
};
